<template>
  <div class="flex flex-col justify-center">
    <button
      v-if="google"
      class="btn-google cursor-pointer rounded flex items-center mb-2 hover:opacity-75"
      :class="{
        'py-2 mb-3': authType === 're_auth',
        'justify-center': authType !== 're_auth',
      }"
      @click="continueWithGoogle"
    >
      <img
        width="24"
        height="24"
        src="https://api.iconify.design/flat-color-icons:google.svg"
        alt="Google"
      />
      <div v-if="authType === 're_auth'" class="ml-3 text-sm text-left">
        <div class="mb-1">{{ $f(lang.continueAs, { account: username }) }}</div>
        <div>{{ googleEmail }}</div>
      </div>
      <div v-if="authType === 'sign_in'" class="btn-text ml-3">
        {{ lang.signInWithSocialGoogle }}
      </div>
      <div v-if="authType === 'sign_up'" class="btn-text ml-3">
        {{ lang.signUpWithSocialGoogle }}
      </div>
    </button>

    <button
      v-if="apple"
      class="btn-apple cursor-pointer rounded flex items-center hover:opacity-75"
      :class="{
        'py-2': authType === 're_auth',
        'justify-center': authType !== 're_auth',
      }"
      @click="continueWithApple"
    >
      <img
        width="24"
        class="w-6 h-6"
        src="https://api.iconify.design/fa-brands:apple.svg?color=%23000"
        alt="Apple"
      />
      <div v-if="authType === 're_auth'" class="ml-3 text-sm text-left">
        <div class="mb-1">{{ $f(lang.continueAs, { account: username }) }}</div>
        <div>{{ appleEmail }}</div>
      </div>
      <div v-if="authType === 'sign_in'" class="btn-text ml-3">
        {{ lang.signInWithSocialApple }}
      </div>
      <div v-if="authType === 'sign_up'" class="btn-text ml-3">
        {{ lang.signUpWithSocialApple }}
      </div>
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'SocialLogin',
  props: {
    authType: {
      type: String, // 'sign_up', 'sign_in', 're_auth'
      required: true,
    },
    google: {
      type: Boolean,
      default: true,
    },
    apple: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState('auth', ['lang', 'username', 'googleEmail', 'appleEmail']),
    uriGoogleLogin() {
      const eventPage = this.authType === 're_auth' ? 'sign_in' : this.authType;
      return `${
        location.origin
      }/signin/module.php/tmauth/googlesigninauthrequest?event_page=${eventPage}&callback=${encodeURIComponent(
        location.href,
      )}`;
    },
    uriAppleLogin() {
      const eventPage = this.authType === 're_auth' ? 'sign_in' : this.authType;
      return `${
        location.origin
      }/signin/module.php/tmauth/applesigninauthrequest?event_page=${eventPage}&callback=${encodeURIComponent(
        location.href,
      )}`;
    },
  },
  mounted() {
    const context = this.authType === 'sign_up' ? 'signup' : 'signin';

    if (window.google) {
      window.google.accounts.id.initialize({
        client_id: process.env.GOOGLE_CLIENT_ID,
        auto_select: false, // optional
        cancel_on_tap_outside: true, // optional
        use_fedcm_for_prompt: true,
        itp_support: true,
        context,
        callback: (data) => this.handleGoogleOAuth(data),
      });

      // if (this.authType !== 're_auth') {
      //   window.google.accounts.id.prompt();
      // }
    }
  },
  methods: {
    ...mapActions(['triggerEvent']),
    continueWithGoogle() {
      this.triggerEvent({ eventName: 'ContinueWithGoogle' });
      if (this.authType === 're_auth') {
        const uri = `${this.uriGoogleLogin}&social_google_email=${encodeURIComponent(
          this.googleEmail,
        )}`;
        location.assign(uri);
        return;
      }

      location.assign(this.uriGoogleLogin);
    },
    handleGoogleOAuth(data) {
      const idToken = data.credential;
      const uri = `${this.uriGoogleLogin}&id_token=${encodeURIComponent(idToken)}`;
      location.assign(uri);
    },
    continueWithApple() {
      this.triggerEvent({ eventName: 'ContinueWithApple' });
      let uri = this.uriAppleLogin;

      if (this.authType === 're_auth') {
        uri += `&social_apple_email=${encodeURIComponent(this.appleEmail)}`;
      }

      location.assign(uri);
    },
  },
};
</script>

<style scoped>
.btn-google {
  border: 1px solid #000000;
  color: #3c4043;
  padding: 10px;
}

.btn-apple {
  border: 1px solid #000000;
  color: #000000;
  padding: 10px;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
}

.btn-text {
  font-weight: 500;
  font-size: 15px;
  line-height: normal;
}
</style>
